import * as React from 'react';
import * as HmiSignalr from '../../hmilib/hmiclientbase';
import * as HmiFiles from '../../hmilib/hmifiles';
import '../../hmilib/hmiglobal';
import { TypeSystemEnum } from '../../hmilib/hmiglobal';
import LoadPage from './../LoadPage';
import LeftMenu from './LeftMenu';

import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStores } from 'store';
import './pole.css';

interface imain {}

const Main = (props: imain) => {
    const { SystemStore } = useStores();
    const [loadstate, setLoadState] = React.useState(false);

    const [NumInst, setNumInst] = React.useState<string>('');
    const [NameState, setNameState] = React.useState<string>('');
    const [TrenName, setTrenName] = React.useState<string>('');

    const [displayLeftMenu, setdisplayLeftMenu] = React.useState('none');
    const [displayLeftMenuOpen, setdisplayLeftMenuOpen] = React.useState('block');
    const [activLeftPanel, setactivLeftPanel] = React.useState('');

    let LoadDeafultMenu = function () {
        if (!HmiSignalr.LoadState || !document.getElementById('mainframe') || !document.getElementById('menumnemo')) {
            setTimeout(LoadDeafultMenu, 300);
            return;
        }

        setTimeout(function () {
            window.OpenNewWindow('menu-pole', 0, null, 'menumnemo');
        }, 100);
    };

    React.useEffect(() => {
        let pagename = 'ПОЛЕ';
        window.TypeSystem = TypeSystemEnum.Pole;

        document.title = pagename + ': ' + NumInst + '. ' + TrenName + ' (' + NameState + ')';

        LoadDeafultMenu();

        return function clear() {
            HmiFiles.CloseAll();
        };
    }, [NumInst, NameState, TrenName]);

    React.useEffect(() => {
        if (displayLeftMenu == 'none') {
            setdisplayLeftMenuOpen('block');
            SetActivLeftPanel(false);
        } else {
            setdisplayLeftMenuOpen('none');
            SetActivLeftPanel(true);
        }

        return function clear() {};
    }, [displayLeftMenu]);

    useEffect(() => {
        if (SystemStore.loadState) {
            setLoadState(true);
        }
    }, [SystemStore.loadState]);

    function SetActivLeftPanel(vision: boolean) {
        const MainFrame = document.getElementById('mainframe');
        if (MainFrame != null) {
            if (vision) MainFrame.classList.add('activLeftPanel');
            else MainFrame.classList.remove('activLeftPanel');
        }
    }

    if (!loadstate) {
        return <LoadPage visible={true} />;
    } else {
        return (
            <div className="pole">
                <div id="main" className="pole-main">
                    <div
                        id="openmenu"
                        className="leftmenu"
                        onClick={() => {
                            setdisplayLeftMenu('block');
                            setdisplayLeftMenuOpen('none');
                            SetActivLeftPanel(false);
                        }}
                        style={{ display: displayLeftMenuOpen }}>
                        <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.17185 4.2034L4.90705 0.87924C4.69145 0.65972 4.34385 0.65972 4.12825 0.87924C3.91265 1.09876 3.91265 1.45268 4.12825 1.6722L7.00585 4.59988L4.12825 7.5298C3.91265 7.74932 3.91265 8.10324 4.12825 8.32276C4.23605 8.43252 4.37685 8.48628 4.51765 8.48628C4.65845 8.48628 4.79925 8.43252 4.90705 8.32276L8.17185 4.9986C8.38745 4.77684 8.38745 4.42292 8.17185 4.2034Z"></path>
                            <path d="M4.87181 4.2034L1.60481 0.87924C1.38921 0.65972 1.04161 0.65972 0.826007 0.87924C0.610407 1.09876 0.610407 1.45268 0.826007 1.6722L3.70581 4.59988L0.828207 7.5298C0.612607 7.74932 0.612607 8.10324 0.828207 8.32276C0.936007 8.43252 1.07681 8.48628 1.21761 8.48628C1.35841 8.48628 1.49921 8.43252 1.60701 8.32276L4.87181 4.9986C5.08741 4.77684 5.08741 4.42292 4.87181 4.2034Z"></path>
                        </svg>
                    </div>

                    <LeftMenu display={displayLeftMenu} setDisplay={setdisplayLeftMenu} />

                    <iframe id="mainframe" className="pole-main__frame"></iframe>
                </div>
            </div>
        );
    }
};

export default observer(Main);
